// extracted by css-extract-rspack-plugin
export default {"setupCard":"_2nGLStBAuYa2hXKBafO364","loadingCard":"_2zKuwLLVAuYVWrlygMSDGk"};